import { Link } from 'react-router-dom'
import { Button, CircularProgress } from '@mui/material'

import { colours } from '../settings/settings'

const MyButton = ({
  error,
  dark,
  light,
  excel,
  pdf,
  txt,
  to,
  toNewTab,
  fitWidth,
  transparent,
  loading,
  borderColor,
  ...rest
}) => {
  let sxProps = {
    padding: '8px',
    fontSize: '1em',
    ...(!fitWidth && { minWidth: '120px' }),
    fontWeight: 'bold',
    color: colours.white,
    border: `1px solid ${colours.black}`,
    backgroundColor: colours.blue,
    ':hover': { backgroundColor: colours.blueDark },
  }

  if (error)
    sxProps = {
      ...sxProps,
      fontWeight: 'normal',
      backgroundColor: colours.red,
      ':hover': { backgroundColor: colours.redDark },
    }

  if (dark)
    sxProps = {
      ...sxProps,
      backgroundColor: colours.blueDark,
      ':hover': { backgroundColor: colours.blueVeryDark },
    }

  if (light)
    sxProps = {
      ...sxProps,
      backgroundColor: colours.blueLight,
      ':hover': { backgroundColor: colours.blue },
    }

  if (excel)
    sxProps = {
      ...sxProps,
      backgroundColor: colours.greenExcel,
      ':hover': { backgroundColor: colours.greenExcelHover },
    }

  if (pdf)
    sxProps = {
      ...sxProps,
      backgroundColor: colours.red,
      ':hover': { backgroundColor: colours.redDark },
    }

  if (txt)
    sxProps = {
      ...sxProps,
      backgroundColor: colours.greyLight,
      ':hover': { backgroundColor: colours.grey },
    }

  if (transparent)
    sxProps = {
      ...sxProps,
      color: colours.black,
      fontWeight: 'normal',
      borderColor: borderColor || 'transparent',
      backgroundColor: 'transparent',
      ':hover': { backgroundColor: colours.greyVeryLight },
    }

  let loadingProps = {}
  if (loading)
    loadingProps = {
      loading: true,
      loadingIndicator: <CircularProgress color='inherit' size='1rem' />,
    }

  const result = <Button {...loadingProps} sx={{ ...sxProps }} {...rest} />

  if (to)
    return <Link to={to} style={{ textDecoration: 'none' }} children={result} />

  if (toNewTab)
    return (
      <Link
        to={toNewTab}
        style={{ textDecoration: 'none' }}
        target='_blank'
        rel='noopener noreferrer'
        children={result}
      />
    )

  return result
}

export default MyButton
